import { render, staticRenderFns } from "./fhc.vue?vue&type=template&id=2ab9e41a&scoped=true&"
import script from "./fhc.vue?vue&type=script&lang=js&"
export * from "./fhc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab9e41a",
  null
  
)

export default component.exports